import ReactGA from "react-ga4";

export const initializeGA4 = (): void => {
  const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;

  if (!measurementId) {
    console.warn("GA4 Measurement ID not found");
    return;
  }

  const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";

  ReactGA.initialize(measurementId, {
    gtagOptions: {
      send_page_view: true,
    },
  });

  if (!isProduction) {
    ReactGA.gtag("config", measurementId, {
      debug_mode: true,
    });
  }

  console.log(
    `GA4 initialized ${!isProduction ? "with DebugView" : "in production"}`,
  );
};

export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, unknown>,
): void => {
  ReactGA.event(eventName, eventParams);
};
